import Bowser from 'bowser';
import { captureError } from '@/sentry';

export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;

  const ua = (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string')
    ? navigator.userAgent
    : '';

  // Bowser-only detection (treat tablets as mobile for v1.5).
  try {
    const platform = Bowser.getParser(ua).getPlatformType(true);
    return platform === 'mobile' || platform === 'tablet';
  } catch (error) {
    captureError(error, { scope: 'mobile', action: 'isMobileDevice' });
    // If UA parsing fails, default to non-mobile to avoid accidentally gating desktop flows.
    return false;
  }
}

export function isLandscape(): boolean {
  if (typeof window === 'undefined') return true;

  const mq = window.matchMedia?.('(orientation: landscape)')?.matches;
  if (typeof mq === 'boolean') return mq;

  const orientationType = window.screen?.orientation?.type;
  if (typeof orientationType === 'string') return orientationType.startsWith('landscape');

  const w = window.innerWidth ?? 0;
  const h = window.innerHeight ?? 0;
  if (w > 0 && h > 0) return w >= h;
  return true;
}

export function onViewportChanged(callback: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const handler = () => callback();
  window.addEventListener('resize', handler);
  window.addEventListener('orientationchange', handler);
  return () => {
    window.removeEventListener('resize', handler);
    window.removeEventListener('orientationchange', handler);
  };
}
